<template>
    <div class="segmented-control" role="tablist">
        <button
            v-for="option in options"
            :key="option.id"
            type="button"
            role="tab"
            class="segmented-control__option"
            :class="{ 'segmented-control__option--active': option.id === value }"
            :aria-selected="option.id === value ? 'true' : 'false'"
            :disabled="option.disabled"
            @click="$emit('input', option.id)"
        >
            <slot name="option" :option="option">{{ option.label }}</slot>
        </button>
    </div>
</template>

<script>
export default {
    name: 'SegmentedControl',
    props: {
        options: { type: Array, required: true },
        value: { type: [String, Number], default: null }
    }
}
</script>

<style lang="scss" scoped>
.segmented-control {
    @include display-flex();
    @include align-items(center);
    padding: 8px;
    @include border-radius(4px);
    background-color: $color-white;

    &__option {
        position: relative;
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        gap: 4px;
        padding: 8px;
        border: none;
        @include border-radius(4px);
        background: transparent;
        font-family: $text;
        font-size: 1rem;
        line-height: normal;
        color: $neutro-s50;
        cursor: pointer;

        &::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            left: 0;
            height: 44px;
            transform: translateY(-50%);
        }

        &--active {
            background-color: $main-t90;
            
            > span:not(.phu-topbar__badge) {
                color: $main-dark;
                font-family: $text-bold;
            }

            
        }

        > .phu-topbar__badge {
            height: 16px;
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
}
</style>
